import { useLocation } from 'react-router-dom'

const useQuery = (name: string): string[] => {
    const value = new URLSearchParams(useLocation().search).getAll(name)
    return value
}

export default useQuery
